import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {City} from '../cities';
import {CityService} from '../cities.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {TreeNode} from 'primeng/api';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule} from "primeng/primeng";

import {TreeModule} from "primeng/tree";
import {RecordDataComponent} from "../../../../components/record-data";
import {MessagesModule} from 'primeng/primeng';
import {MessageModule} from 'primeng/message';
import {AppArcComponent} from "../../../../components/app-arc";
import {UserSettingsComponent} from "../../../../components/user-settings";
import {UserProfileComponent} from "../../../../components/user-profile";
import {ParentShowComponent} from "../../../../components/parent-show";
import {ItemsGroupsShowComponent} from "../../itemsGroups/itemsGroups-show/itemsGroups-show.component";
import {OrganizationShowComponent} from "../../organization/organization-show/organization-show.component";


@NgModule({
    imports: [CommonModule, FormsModule, TreeModule, DropdownModule, MessagesModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        CitiesShowComponent
    ],
    entryComponents: [
        CitiesShowComponent
    ],
    exports: [],
    providers: [SharedService, CityService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-cities-show',
    templateUrl: './cities-show.component.html',
    styleUrls: ['./cities-show.component.scss'],
    providers: [CityService, ConfirmationService, MessageService]
})

export class CitiesShowComponent implements OnInit, AfterViewInit {
    id: string;
    city: City;
    applog: AppLogComponent;
    @Input() delId;
    @Input() modelName;
    @Input() oldData;
    @Input() newData;
    @Input() refShow;
    @Input() scrId;


    cityForm: FormGroup;
    catVal = [{'val': 1, 'title': 'Country'}, {'val': 2, 'title': 'State'}, {'val': 3, 'title': 'City'}];
    modalRef: NgbModalRef;

    cities: any[] = [];
    tree: TreeNode[];
    parent: any;
    private sub: any;
    msgs: Message[] = [];

    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private cityService: CityService,
                public activeModal: NgbActiveModal,
                private modalService: NgbModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},

        ]);
        this.sharedservice.setModelName('');

    }

    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.city;
        modalRef.componentInstance.rowId = '';

    }

    ngAfterViewInit() {
        if(!this.scrId) {

            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');


            if (this._editButton) {
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/cities/edit', this.id]);
                });
            }
            if (this._deleteButton) {
                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteCity(this.city);
                });
            }
            if (this._newButton) {
                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/cities']);
                });
            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/cities/search']);
                });
            }
        }
    }

    ngOnInit() {
        this.msgs=[];
        this.cityService.getAllCities().subscribe(
            cities => {
                this.cities = cities;
            });
        this.cityService.getTree('0').then(tree => this.tree = tree);
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.cityForm = new FormGroup({
            id: new FormControl({value: '', disabled: true}, Validators.required),
            name: new FormControl({value: '', disabled: true}, Validators.required),
            parent_id: new FormControl({value: '', disabled: true}, Validators.required),
            category: new FormControl({value: '', disabled: true}, Validators.required)

        });

        if (this.id) {
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;

            this.delId = false;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs = [];
            }
            this.cityService.getById(this.id).subscribe(
                city => {
                    this.id = city.id;
                    this.city = city;
                    this.parent = city.parent_id;
                    this.cityForm.patchValue({
                        id: city.id,
                        name: city.name,
                        parent_id: city.parent_id,
                        category: city.category,
                    });
                }, error => {
                    console.log(error);
                }
            );


        }
        if (this.scrId) {
            //this.activeModal.dismiss('');

            this.oldData = false;
            this.newData = false;

            this.delId = false;

            this.cityService.getById(this.scrId).subscribe(
                city => {
                    this.id = city.id;
                    this.city = city;
                    this.cityForm.patchValue({
                        id: city.id,
                        name: city.name,
                        parent_id: city.parent_id,
                        category: city.category,
                    });
                }, error => {
                    console.log(error);
                }
            );


        }

        if (this.delId) {
            this.oldData = false;
            this.newData = false;
            this.cityService.getTrashedById(this.delId).subscribe(
                city => {
                    this.id = city.id;
                    this.city = city;
                    this.cityForm.patchValue({
                        id: city.id,
                        name: city.name,
                        parent_id: city.parent_id,
                        category: city.category,

                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
            this.city = this.newData;
            this.cityForm.patchValue({
                id: this.newData.id,
                name: this.newData.name,
                parent_id: this.newData.parent_id,
                category: this.newData.category,

            });
        }
    }

    showParent() {
        if (this.parent) {
            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    console.log("before dismiss");
                    //
                    return true;
                }
            };
            this.modalRef = this.modalService.open(CitiesShowComponent, options);
            this.modalRef.componentInstance.scrId = this.parent;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('setting.cities.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteCity(city: City) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (city) {
                    this.cityService.delete(city.id).subscribe(
                        res => {
                            if (res.result) {
                                this.msgs = [];
                                this.msgs.push({
                                    severity: 'success',
                                    summary: '',
                                    detail: this.translate.instant('Delete completed')
                                });
                                setTimeout(() => {
                                    this.router.navigate(['/cities']);
                                },1000);
                            } else {
                                this.msgs = [];
                                this.msgs.push({
                                    severity: 'error',
                                    summary: '',
                                    detail: this.translate.instant(res.message)
                                });
                            }
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));

                        }
                    );
                }
            }
        });
    }

    nodeSelect(_id: string) {
        this.cityService.getById(_id).subscribe(
            city => {
                this.id = city.id;
                this.city = city;
                this.cityForm.patchValue({
                    id: city.id,
                    name: city.name,
                    parent_id: city.parent_id,
                    category: city.category
                });
            }, error => {
                console.log(error);
            });
    }

    addnew(_id: string) {
        this.router.navigate(['/cities', _id]);
    }

    recoverEdit(city: City) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (city) {
                    this.cityService.update(city).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/cities/show', city.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.cityService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted item recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/cities/list']);
                        }
                    );
                }
            }
        });
    }


    showattachement(row_id: string) {
        console.log(row_id)
        if (row_id) {
            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    // this.changePicUrl();
                    return true;
                }
            };
            const modalRef = this.modalService.open(AppArcComponent, options);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.screenName = this.modelName;
        }
    }

    showHistory(row_id: string) {
        if (row_id) {
            const modalRef = this.modalService.open(AppLogComponent);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.refShow = CitiesShowComponent;

        }
    }


}



// WEBPACK FOOTER //
// ./src/app/views/setting/cities/cities-show/cities-show.component.ts